<template>
	<div class="rain-button-container">
		<div class="img-container">
			<img src="/heavy-rain.svg" alt="">
		</div>
	</div>
</template>

<script>
export default {
	name: 'RainButton',
	props: ['rain'],
}
</script>

<style lang="less">
  .rain-button-container {
  position: relative;
  width: 100%;
  height: 200px;
  cursor: pointer;
  display: block;
  margin: 0 auto;

  &:hover img {
  animation: vibrate-3 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;

  /*animation: jello-horizontal 0.8 both;*/
  }

  .img-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;

  img {
  width: 100%;
  }
  }

  @media (max-width: 1024px) {
      height: 100px;
      
    .img-container {
      width: auto;
    }
  }
  
   @media (max-width: 450px) {
        height: 50px;
   }

  /* ----------------------------------------------
  * Generated by Animista on 2020-4-21 19:17:59
  * Licensed under FreeBSD License.
  * See http://animista.net/license for more info.
  * w: http://animista.net, t: @cssanimista
  * ---------------------------------------------- */

  /**
  * ----------------------------------------
  * animation vibrate-3
  * ----------------------------------------
  */
  @keyframes vibrate-3 {
  0% {
  transform: translate(0);
  }
  10% {
  transform: translate(-2px, -2px);
  }
  20% {
  transform: translate(2px, -2px);
  }
  30% {
  transform: translate(-2px, 2px);
  }
  40% {
  transform: translate(2px, 2px);
  }
  50% {
  transform: translate(-2px, -2px);
  }
  60% {
  transform: translate(2px, -2px);
  }
  70% {
  transform: translate(-2px, 2px);
  }
  80% {
  transform: translate(-2px, -2px);
  }
  90% {
  transform: translate(2px, -2px);
  }
  100% {
  transform: translate(0);
  }
  }

  }

</style>
